export { Animation } from './Animation.es.js';
export { getEasingFunction } from './utils/easing.es.js';
